/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiagnoseSurveyTakerCto } from '../../models/diagnose-survey-taker-cto';

export interface GetSurveyTakersAsync$Plain$Params {
  companyGuid: string;
  surveyId: string;
}

export function getSurveyTakersAsync$Plain(http: HttpClient, rootUrl: string, params: GetSurveyTakersAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DiagnoseSurveyTakerCto>>> {
  const rb = new RequestBuilder(rootUrl, getSurveyTakersAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
    rb.path('surveyId', params.surveyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DiagnoseSurveyTakerCto>>;
    })
  );
}

getSurveyTakersAsync$Plain.PATH = '/diagnose/xp-survey-actions/company/{companyGuid}/surveys/{surveyId}/takers';
